import { useMutation, useQueryClient } from "@tanstack/react-query";

import api from "@/shared/api";
import { Data } from "@/shared/types.ts";

/** Деньги, вернувшиеся клиенту через эквайринг. */
export type RefundMoney = {
  orderId: number;
  paymentId: number;
  amount: number;
  refundedAmount: number;
  externalId: string;
  alreadyRefunded: boolean;
};

/** Чек возврата в очереди фискализации. Пустой, если деньги ушли, а чек нет. */
export type RefundFiscal = {
  id: number;
  externalCheckNumber: string;
  isFiscalized: boolean;
};

export type OrderRefundResult = {
  money: RefundMoney | null;
  fiscal: RefundFiscal | null;
};

/**
 * Возврат по заказу: деньги через эквайринг плюс фискальный чек возврата.
 * Сумма 0 означает полный возврат оплаченной суммы. Повторный вызов деньги
 * второй раз не вернёт — payments-service считает уже возвращённое.
 */
export function useRefundOrder({ orderId }: { orderId: string | number }) {
  const queryClient = useQueryClient();

  return useMutation<Data<OrderRefundResult>, Error, { amount: number }>({
    mutationFn: (data) =>
      api.post(`/api/v1/orders/admin/${orderId}/refund`, { json: data }).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orders", "price", orderId] });
      queryClient.invalidateQueries({ queryKey: ["orders", orderId] });
    },
  });
}
